// apiDetector.ts
// ———————————————————————————————————————————————————————————————
// Detección de API SCORM en la jerarquía de ventanas
// ———————————————————————————————————————————————————————————————

import type { ScormAPI, Version } from './types';

interface DetectionResult {
  api: ScormAPI;
  version: Version | null;
}

/**
 * Busca la API SCORM en la jerarquía de ventanas (parent, opener)
 * Soporta SCORM 1.2 (API) y SCORM 2004 (API_1484_11)
 */
export function findScormAPI(win: Window): DetectionResult {
  let attempts = 0;
  const maxAttempts = 500;

  while (win && attempts < maxAttempts) {
    attempts++;

    // SCORM 2004
    if ((win as any).API_1484_11) {
      return {
        api: (win as any).API_1484_11,
        version: "2004"
      };
    }

    // SCORM 1.2
    if ((win as any).API) {
      return {
        api: (win as any).API,
        version: "1.2"
      };
    }

    // Subir en la jerarquía
    if (win.parent && win.parent !== win) {
      win = win.parent;
    } else if (win.opener) {
      win = win.opener;
    } else {
      break;
    }
  }

  return {
    api: null,
    version: null
  };
}
